import * as React from 'react';
import { marginClass, mergeSpacingProps, paddingClass } from './spacing';
export function useSpacingProps(props) {
  var marginClasses = React.useMemo(function () {
    return marginClass(mergeSpacingProps({
      spacing: props.margin,
      spacingBottom: props.marginBottom,
      spacingLeft: props.marginLeft,
      spacingRight: props.marginRight,
      spacingTop: props.marginTop,
      spacingX: props.marginX,
      spacingY: props.marginY
    }));
  }, [props.margin, props.marginBottom, props.marginLeft, props.marginRight, props.marginTop, props.marginX, props.marginY]);
  var paddingClasses = React.useMemo(function () {
    return paddingClass(mergeSpacingProps({
      spacing: props.padding,
      spacingX: props.paddingX,
      spacingY: props.paddingY,
      spacingTop: props.paddingTop,
      spacingBottom: props.paddingBottom,
      spacingLeft: props.paddingLeft,
      spacingRight: props.paddingRight
    }));
  }, [props.padding, props.paddingBottom, props.paddingLeft, props.paddingRight, props.paddingTop, props.paddingX, props.paddingY]);
  return {
    paddingClasses: paddingClasses,
    marginClasses: marginClasses
  };
}